module.exports = __webpack_public_path__ + "static/media/addShippingCost.a7548ea5.svg";